import dynamic from 'next/dynamic'

import { type SanityTeamMember } from '@data/sanity/queries/types/blocks'

const Photo = dynamic(() => import('@components/photo'))

interface HorizontalTeamMemberCardProps {
  teamMember: SanityTeamMember
}

const HorizontalTeamMemberCard = ({
  teamMember,
}: HorizontalTeamMemberCardProps) => {
  if (!teamMember) {
    return null
  }

  const { name, fullName, jobTitle, photo } = teamMember

  return (
    <div className="flex items-center relative pb-8">
      {photo && (
        <Photo
          image={photo}
          width={100}
          height={100}
          className="flex-none rounded-full overflow-hidden"
          imageClassName="object-cover"
        />
      )}

      <div className="flex-auto ml-6">
        <h5 className="text-2xl mt-3">{fullName ?? name}</h5>
        {jobTitle && <p className="text-base">{jobTitle}</p>}
      </div>
    </div>
  )
}

export default HorizontalTeamMemberCard
